import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/backoffice/customers/$customerId/',
)({
  head: () => ({
    meta: [{ title: 'Cliente' }],
  }),
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/backoffice/customers/$customerId/general', params });
  },
});
